import React from "react";
import { FormattedMessage } from "react-intl";
import type { IRaangeLabelProps } from "src/shared/components/RaangeLabel";
import { RaangeLabel } from "src/shared/components/RaangeLabel";

export const LookupLabel = (props: Omit<IRaangeLabelProps, "fa">) => {
  return (
    <RaangeLabel fa="robot" {...props}>
      <FormattedMessage id="lookup" />
    </RaangeLabel>
  );
};
